const tipoEstadoCivilList = [
    {
        id: 'S',
        descricao: 'Solteiro(a)',
        ordem: 10,
    },
    {
        id: 'C',
        descricao: 'Casado(a)',
        ordem: 20,
    },
    {
        id: 'P',
        descricao: 'Separado(a)',
        ordem: 30,
    },
    {
        id: 'J',
        descricao: 'Separado(a) Judicialmente',
        ordem: 40,
    },
    {
        id: 'D',
        descricao: 'Divorciado(a)',
        ordem: 50,
    },
    {
        id: 'V',
        descricao: 'Viúvo(a)',
        ordem: 60,
    },
    {
        id: 'U',
        descricao: 'União Estável',
        ordem: 70,
    },
]

export default tipoEstadoCivilList